import { AboutUsComponent } from '../../Modules/Homepage/about-us/about-us.component';
import { BannerEnquiryFormComponent } from '../../Modules/banner-enquiry-form/banner-enquiry-form.component';
import { Component } from '@angular/core';
import { FeaturesComponent } from "../../Modules/Homepage/features/features.component";
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { HomePageComponent } from '../home-page/home-page.component';
import { HowItWorksComponent } from "../../Modules/Homepage/how-it-works/how-it-works.component";
import { PartnersComponent } from "../../Modules/Homepage/partners/partners.component";
import { TestimonialComponent } from "../../Modules/Homepage/testimonial/testimonial.component";
import { TopRatedMutualFundsComponent } from "../../Modules/Homepage/top-rated-mutual-funds/top-rated-mutual-funds.component";
import { WhyChooseUsComponent } from "../../Modules/Homepage/why-choose-us/why-choose-us.component";

@Component({
  selector: 'app-website-template',
  templateUrl: './website-template.component.html',
  styleUrl: './website-template.component.scss',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, HomePageComponent,  TopRatedMutualFundsComponent, WhyChooseUsComponent, TestimonialComponent, PartnersComponent, HowItWorksComponent, FeaturesComponent]
})
export class WebsiteTemplateComponent {}
